import { getApiErrorMessage } from "../utils/apierror";
import { BaseService } from "./BaseService";

export class PortfolioService extends BaseService {
  async getPortfolios(profileId) {
    const result = await super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.GETPORTFOLIOS + "?profileID=" + profileId
    );
    if (!Array.isArray(result)) {
      throw new Error(getApiErrorMessage(result, "Unable to download Portfolios. Please try again."));
    }
    return result.map((item) => {
      item.portfolioGroupID = item.portfolioGroupID ? item.portfolioGroupID : "";
      item.portfolioGroup = item.portfolioGroup ? item.portfolioGroup : "";
      return item;
    });
  }
}
